export default __webpack_public_path__ + "static/media/AutumnBook_02.d61db456.png";